/* tab标签导航栏 */
export function removeTab (tabName, that) {
  let TabList = JSON.parse(JSON.stringify(that.TabList))
  that.TabList = that.TabList.filter(item => item.name !== tabName)
  // 如果关闭的是当前选择的标签
  if (tabName === that.activeTab) {
    let i = TabList.length
    // 找出所关闭标签的下标
    while (i--) {
      if (TabList[i].name === that.activeTab) {
        break
      }
    }
    // 如果标签长度大于2个
    if (TabList.length >= 2) {
      if (i === 0) {
        that.$router.push({ name: TabList[1].name }, () => {
          that.activeTab = that.$route.name
        })
      } else {
        that.$router.push({ name: TabList[i - 1].name }, () => {
          that.activeTab = that.$route.name
        })
      }
    } else {
      that.$router.push('/index')
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/removeTab.js